<template>
    <h1>404 Page Not Found!</h1>
</template>

<script>
    export default {
        name: 'FourOhFour'
    }
</script>


// WEBPACK FOOTER //
// FourOhFour.vue?098d4fa0